/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Choice from './Choice/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/Gender"
  
}) {
let gendersValueData = fromData.useDataValue({ viewPath,
context: 'genders',
})
  return (<React.Fragment
>
<div
  data-testid="Gender.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(gendersValueData) && gendersValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="option"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Choice(${item?.id ?? item?._id ?? index})`}
      >
<Choice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Choice(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }